export const getData = (state) => state.device.data;
export const getErrors = (state) => state.device.errors;
export const getIsFetching = (state) => state.device.isFetching;
